import React, { createContext, useState,  useContext, useEffect} from 'react';
import { authenticated } from './AuthService'

export type Event = {
    id: number,
    createrId: number,
    title: string,
    description: string,
    summary: string,
    updatedAt: Date,
    createdAt: Date,
}

export type AuthState = {
    isAuthenticated: boolean;
    user: any,
    event: any,
    updateAuthState:(data:any) => {},
    updateUser:(data:any) => {},
    updateEvent:(data:any) => {},
    
};

export const AuthContext = createContext<AuthState>({
    isAuthenticated: false,
    user: null,
    event: null,
    updateAuthState: ():any => {},
    updateUser: ():any => {},
    updateEvent: ():any => {},
});


export const AuthProvider: any = ({ children }: { children: React.ReactNode }) => {
    const [authState, setAuthState] = useState({
        isAuthenticated: false,
        user: null,
        event: null,
    });
    
    useEffect((): any=>{
        let user = authenticated();
        if(user){
            setAuthState({...authState, isAuthenticated: true})
        }
        else{
            setAuthState({...authState, isAuthenticated: true})
        }
    },[])

    
    const updateAuthStateValue = {
        isAuthenticated: authState.isAuthenticated,
        user: authState.user,
        event: authState.event,
        updateAuthState: (isAuthenticated:any):any => {
            setAuthState({...authState, isAuthenticated: isAuthenticated})
        },
        updateUser: (user:any):any => {
            setAuthState({...authState, user: user})
        },
        updateEvent: (user:any):any => {
            setAuthState({...authState, event: user})
        },
    } 

   
    return (
        <AuthContext.Provider value={updateAuthStateValue}> 
            {children}
        </AuthContext.Provider>
    );

}

export const useAuthState = () => useContext(AuthContext);
